import React, { useEffect, useMemo, useRef, useState } from 'react';
import './style.scss';
import cat from './cat.png'
import PersonalCabinet from "../PersonalCabinet";
import { useModal } from "react-modal-hook";
import PanModal from "../../components/core/PanModal";
import Dropdown from "../../components/core/Dropdown";
import Button from "../../components/core/Button";
import SubmitButton from "../../components/SubmitButton";
import { Link } from "react-router-dom";
import useClickPast from "../../hooks/useClickPast";
import {
  CabinetTreeActionAddIcon, CabinetTreeActionDeleteIcon,
  CabinetTreeActionEditIcon,
  CabinetTreeActionIcon
} from "../../components/Public/markup/icons";
import SimpleBar from "simplebar-react";
import { filterAndMap } from "../Fixations/Components";
import Modal from "../../components/core/Modal";
import useObjectState, { ObjectStateProvider, useObjectStateContext } from '../../hooks/useObjectState';
import useApiManager, { ApiProvider, useApiManagerContext } from '../../hooks/useApiManager';
import useModalWithData from '../../hooks/useModalWithData';
import classNames from 'classnames';
import Avatar from "react-avatar";
import Preloader from '../../components/Preloader';
import EmptyTable from '../../components/core/EmptyTable';
import DepartmentCard from './DepartmentCard';
import InputMask from "react-input-mask";
import { errorToast, standartErrorToast, standartSuccessToast, successToast } from '../../components/toasts';
import useApi from '../../hooks/useApi';
import { toFormData } from '../../utils';
import useCompanyRole from '../../hooks/useCompanyRole';


const OrgChartPage = () => {

  return <ApiProvider
    value={{}}

    requests={[
      { action: "getCompanyEmployees" },
      { action: "removeDepartament" },
      { action: "updateDepartament" },
      { action: "addDepartament" },
      { action: "getMyCompany" },
      { action: "removeCompany" },
      { action: "moveEmployee" },
      { action: "editEmployee" },
      { action: "getEmployee" },
      { action: "addEmployee" },

    ]}

    config={{
      defaultPayload: { c: "panpartner:company.ajax" },
      initialState: {
        loadingState: ["getCompanyEmployees", "getMyCompany"],
        departments: [],
        employees: [],
        company: {},
        hiddenTrees: [],
        full_acess_company: false,
        full_acess_department: false,
        access_edit_departament: false,
      }
    }}>
    <OrgChartPageContent />
  </ApiProvider>
}

export default OrgChartPage;

const OrgChartPageContent = () => {

  const {
    state,
    setValue,
    setValues,

    getCompanyEmployees,
    addDepartament,

    removeDepartament,
    updateDepartament,
    getMyCompany,

    removeCompany,
    moveEmployee,
    editEmployee,
    getEmployee,
    addEmployee
  } = useApiManagerContext();

  const isReadOnly = useCompanyRole(["full_access_departament"]);

  const getEmployees = (requestID) => {
    getCompanyEmployees({ requestID }, requestID ?? "getCompanyEmployees").then(({ resp: { employees, access_list, full_acess_company, full_acess_department, access_edit_departament } }) => {
      setValues({
        company,
        employees,
        access_list: Array.isArray(access_list) ? access_list.map(v => ({ id: v.value, ...v })) : [],
        full_acess_company,
        full_acess_department,
        access_edit_departament,
      })
    })
  }
  const getCompany = (requestID) => {
    Promise.all([getCompanyEmployees({}, requestID ?? "getCompanyEmployees"), getMyCompany({}, requestID ?? "getMyCompany")])
      .then(([{ resp: { employees, access_list, full_acess_company, full_acess_department, access_edit_departament } }, { resp: { company } }]) => {
        setValues({
          departments: company?.departments,
          company,
          employees,
          access_list: Array.isArray(access_list) ? access_list.map(v => ({ id: v.value, ...v })) : [],
          full_acess_company,
          full_acess_department,
          access_edit_departament,
        })
      })
  }

  useEffect(() => {
    getCompany()
  }, [])

  const {
    loadingState,
    departments = [],
    employees = [],
    company,
    hiddenTrees,
    access_list
  } = state;

  const toggleTree = parentId => setValue("hiddenTrees", prev => prev.includes(parentId) ? prev.filter(v => v !== parentId) : [...prev, parentId]);

  const setDepartmentValues = (departmentId, values) => {
    setValue('departments', (prev) => {
      const tmp = [...prev];
      const index = tmp.findIndex((item) => item.id === departmentId);
      tmp[index] = { ...tmp[index], ...(typeof values === "function" ? values(tmp[index]) : values) };
      return tmp;
    })
  }

  const setEmployerValues = (employeerId, values) => {
    setValue('employees', (prev) => {
      const tmp = [...prev];
      const index = tmp.findIndex((item) => item.id === employeerId);
      tmp[index] = { ...tmp[index], ...(typeof values === "function" ? values(tmp[index]) : values) };
      return tmp;
    })
  }

  const addNewDepartmnent = ({ parentId, }) => {


    const departmentsLength = departments.length;

    const parentDepartment = departments.find(dep => dep.id === parentId);

    const status = parentId ? parentDepartment.status === "general" ? "second" : "last" : 'general';

    const newDepartment = {
      id: departmentsLength,
      name: `Новый отдел ${departmentsLength}`,
      employees: [],
      generalDirector: false,
      status,
      departments: [],
      parentId,
    }

    setValue("departments", prevDepartments => ([
      ...prevDepartments,
      newDepartment
    ]))
    addDepartament({ parentId, name: `Новый отдел ${departmentsLength}`, }).then(r => getCompany("reset"))
  }
  const handleEditEmploye = (employeeValues = {}) => {
    const params = {
      employeeId: employeeValues?.id,
      departmentId: employeeValues?.departmentId,
      position: employeeValues?.position, //director || agent уточнить, есть ущё post у пользователя
      comment: employeeValues?.comment || "",
      access: employeeValues?.access,
    }

    setEmployerValues(employeeValues.id, employeeValues)
    editEmployee(params).then(r => {
      getCompany("reset")
    })
    closeUserInfoModal()
  }

  const handleDeleteDepartment = ({ departmentToRemoveId, targetDepartmentId, isMainDep }) => {

    if (isMainDep) return removeCompany().then(() => window.location.reload())
    removeDepartament({ departmentToRemoveId, targetDepartmentId }).then(resp => {
      setValue('departments', (prev) => {
        const tmp = [...prev];
        const removedIndex = tmp.findIndex((item) => item.id === departmentToRemoveId);
        const targetIndex = tmp.findIndex((item) => item.id === targetDepartmentId);
        tmp[targetIndex] = { ...tmp[targetIndex], employees: [...tmp[targetIndex].employees, ...tmp[removedIndex].employees] };
        tmp.splice(removedIndex, 1)
        return tmp;
      })
      getCompany("reset")
    }, standartErrorToast)
  }

  const handleUpdateDepartment = (depValues = {}) => {
    const department = departments.find(d => d.id === depValues.id)

    const params = {
      id: depValues.id,
      parentId: depValues.parentId,
      name: depValues.name,
      headId:  depValues.headId ?? depValues.head?.id,
    }
    setDepartmentValues(depValues.id, params)
    updateDepartament(params).then(({ resp }) => {
      if (resp.status === "error") return;
      successToast("Отдел обновлён")
      getCompany("reset")
    }, standartErrorToast)

  }

  const {
    openModal: openDeleteConfirmModal,
  } = useModalWithData({
    content: ({ closeModal, id, parentDep, isMainDep, childrens = [], setValue, selectedDep }) => <Modal
      withoutBG
      classes="crm-table__sf-controlsmodal crm-table__sf-controlsmodal_fixation crm-table__sf-controlsmodal_fixation-tree"
      closeByPastClick close={closeModal}
    >
      {!isMainDep && <>
        <div className="crm-table__sf-controlsmodaltitle">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8.5" stroke="#EF372E" /><line x1="12.0435" y1="7.5" x2="12.0435" y2="13.5" stroke="#EF372E" stroke-linecap="round" /><circle cx="12.0435" cy="15.5" r="0.5" fill="#EF372E" /></svg>
          Удалить подразделение?
        </div>
        <div className="crm-table__sf-controlsmodaltitle">
          Перенести сотрудников
        </div>
        <Dropdown
          value={selectedDep ?? parentDep?.id}
          options={departments.filter(d => d.id !== id && !childrens.some(({ id }) => d.id === id))}
          onChange={v => setValue("selectedDep", v)}
          titleKey="name"

        />
      </>}
      {isMainDep && <><div className="crm-table__sf-controlsmodaltitle">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8.5" stroke="#EF372E" /><line x1="12.0435" y1="7.5" x2="12.0435" y2="13.5" stroke="#EF372E" stroke-linecap="round" /><circle cx="12.0435" cy="15.5" r="0.5" fill="#EF372E" /></svg>
        Удалить компанию?
      </div>
        <span>Все сотрудники будут удалены</span>
      </>}

      <div className="crm-table__sf-controlsmodalbtns">
        <Button buttonType="line" onClick={closeModal}>Отменить</Button>
        <Button
          buttonType="primary"
          onClick={() => {
            closeModal()
            handleDeleteDepartment({ departmentToRemoveId: id, targetDepartmentId: selectedDep ?? parentDep?.id, isMainDep })
          }}
        >
          Удалить
        </Button>
      </div>
    </Modal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: []
  })

  const mainDepartment = useMemo(() => departments.find(dep => dep.parentId === 0) || {}, [departments])

  const generalDepartments = useMemo(() => departments.filter(dep => dep.parentId === 0), [departments])

  const companyOwner = useMemo(() => departments.find(dep => dep.parentId === 0)?.generalDirector, [departments])

  const [draggedOverDepartment, setDraggedOverDepartment] = useState(null);

  const handleDragStart = (e, entity, isDirector = false) => {
    if (isReadOnly) return;
    e.dataTransfer.setData('entity-id', entity.id);
    e.dataTransfer.setData('is-director', isDirector);
    e.dataTransfer.effectAllowed = 'move';
  };


  const handleDrop = (e, targetDepartment) => {
    if (isReadOnly) return;
    e.preventDefault();

    //был ли чел руководителем, до того как его положили в другую карточку (или в ту же самую)
    const isDirector = e.dataTransfer.getData('is-director') === 'true';

    const employeeIndex = employees.findIndex(empl => empl.id === +e.dataTransfer.getData('entity-id'))

    const employee = employees[employeeIndex];

    const departamentIndex = departments.findIndex(dep => dep.id === targetDepartment);

    const departament = departments[departamentIndex]

    const tmpEmpl = [...employees]

    tmpEmpl[employeeIndex] = { ...employee, departament }

    const isGendirDropZone = e.target.parentNode?.id?.includes?.("gendirDropZone");

    const tmpDepartments = [...departments]

    const previousDepartmentIndex = departments.findIndex(dep => dep.generalDirector?.id === employee.id)

    if (isGendirDropZone) tmpDepartments[departamentIndex] = { ...departament, generalDirector: employee }

    if (tmpDepartments[previousDepartmentIndex] && isDirector) tmpDepartments[previousDepartmentIndex] = {
      ...tmpDepartments[previousDepartmentIndex],
      generalDirector: false
    }
    const updateParams = {
      employeeId: employee.id,
      departmentId: targetDepartment,
      type: isGendirDropZone ? "director" : "agent"
    }
    moveEmployee(updateParams)
    setValues((prev) => {

      return {
        ...prev,
        employees: tmpEmpl,
        ...(isGendirDropZone || isDirector ? { departments: tmpDepartments } : [])
      }
    })

    return setDraggedOverDepartment(null);

  };


  const onDragOverCard = (e, department) => {
    if (isReadOnly) return;
    e.stopPropagation();
    e.preventDefault();
    if (department?.id !== draggedOverDepartment?.id) setDraggedOverDepartment(department);
  }

  const handleDragLeave = (e) => {
    if (!draggedOverDepartment) return
    setDraggedOverDepartment(null);
  };

  const [createSubdivisionModal, closeCreateSubdivisionModal] = useModal(
    () => (
      <PanModal customClass="tree-modal" isSmall title={'Создать подразделение'} closeModal={closeCreateSubdivisionModal}>
        <SubdivisionModal departments={departments} access_list={access_list} closeModal={closeCreateSubdivisionModal} />
      </PanModal>
    ),
    [],
  );
  const {
    openModal: openCreateUser,
  } = useModalWithData({
    content: ({ closeModal }) => <PanModal customClass="tree-modal" isSmall title={'Добавить сотрудника'} closeModal={closeModal}>
      <UserCreateModal
        departments={departments}
        access_list={access_list}
        employees={employees}
        handleSave={addEmployee}
        closeModal={closeModal}
      />
    </PanModal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: [access_list, addEmployee]
  })
  const {
    openModal: openEditDepModal,
  } = useModalWithData({
    content: ({ closeModal, department, parentDepartment, isMainDep }) => <PanModal customClass="tree-modal" isSmall title={'Редактировать подразделение'} closeModal={closeModal}>
      <SubdivisionModal
        department={department}
        departments={departments}
        parentDepartment={parentDepartment}
        access_list={access_list}
        employees={employees}
        isMainDep={isMainDep}
        handleSave={handleUpdateDepartment}
        closeModal={closeModal}
      />
    </PanModal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: [departments, employees]
  })

  const {
    openModal: createUserInfoModal,
    closeModal: closeUserInfoModal
  } = useModalWithData({
    content: ({ closeModal, user, userDepartment, parentDep, isGendir }) => <PanModal customClass="tree-modal" isSmall title={'Информация о сотруднике'} closeModal={closeModal}>
      <UserInfoModal
        user={user}
        userDepartment={userDepartment}
        departments={departments}
        getEmployee={getEmployee}
        access_list={access_list}
        handleSave={handleEditEmploye}
        closeModal={closeModal}
        isGendir={isGendir}
        parentDep={parentDep}
        companyOwner={companyOwner}
        disableSave={isReadOnly}
      />
    </PanModal>,
    modalProps: {
      withoutBG: true,
      closeByPastClick: true,
      classes: "crm-table__sf-controlsmodal crm-table__sf-controlsmodal_compilation",
    },
    dep: [departments]
  })


  const isPageLoading = loadingState.includes("getCompanyEmployees") || loadingState.includes("getMyCompany");

  if (isPageLoading) return <Preloader loading />

  if (!company) return <EmptyTable
    title="Вы еще не создали компанию"
    link="/personalcabinet/company?create=true"
    button="Создать"
  />

  return (
    <>
      {false && <div>
        <button onClick={createSubdivisionModal}>создать подразделение</button>
        <button onClick={createUserInfoModal}>информация о сотруднике</button>
        <div className="recursion-block">
          <div className="recursion-block__card">
            <div className="recursion-block__card-header">
              <span>Отдел четвертого уровня</span>
              <span>
                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.2419 9L13.3935 12L16.5451 9" stroke="white" stroke-linecap="round" />
                  <path d="M10.2419 15L13.3935 12L16.5451 15" stroke="white" stroke-linecap="round" />
                </svg>
              </span>
            </div>
            {/* <DepartmentCard
              title={mainDepartment.name}
              employees={employees.filter(empl => empl.departament?.id === mainDepartment.id)}
              generalDirector={generalDirectors.find((d) => d.department === mainDepartmentId)}
              onDrop={(e) => handleDrop(e, mainDepartmentId)}

              onDragEnter={(e) => handleDragEnter(e, mainDepartmentId)}

              onDragLeave={handleDragLeave}

              onDragStart={handleDragStart}
              isDraggedOver={draggedOverDepartment === mainDepartmentId}
              onAddSubDepartment={handleAddMainDepartment}
              status="general"
              childrensCount={0}
              showChildrens={showChildrens}
              setShowChildrens={setShowChildrens}
              createSubdivisionModal={createSubdivisionModal}
              createUserInfoModal={createUserInfoModal}
              onDelete={() => openDeleteConfirmModal(mainDepartmentId)}
            /> */}
            {/* <DepartmentCard
              title={mainDepartmentId}
              employees={employees.filter(empl => empl.departament?.id === mainDepartmentId)}
              generalDirector={generalDirectors.find((d) => d.department === mainDepartmentId)}
              onDrop={(e) => handleDrop(e, mainDepartmentId)}
              onDragEnter={(e) => handleDragEnter(e, mainDepartmentId)}
              onDragLeave={handleDragLeave}
              onDragStart={handleDragStart}
              isDraggedOver={draggedOverDepartment === mainDepartmentId}
              onAddSubDepartment={handleAddMainDepartment}
              status="general"
              childrensCount={0}
              showChildrens={showChildrens}
              setShowChildrens={setShowChildrens}
              onDelete={() => openDeleteConfirmModal(mainDepartmentId)}
            /> */}
          </div>
        </div>
      </div>}
      <div className="org-chart-page" >
        <main className="org-chart-page__main">
          {generalDepartments.map(mainDepartment => {

            const children = departments.filter((dep) => dep.parentId === mainDepartment.id);

            return <div className="main-department-group">
              <DepartmentCard
                title={mainDepartment.name}
                employees={employees.filter(empl => empl.departament?.id === mainDepartment.id && empl.id !== mainDepartment.generalDirector?.id)}
                generalDirector={mainDepartment.generalDirector}

                onDragOver={e => onDragOverCard(e, mainDepartment)}
                onDrop={(e) => handleDrop(e, mainDepartment.id)}
                onDragStart={handleDragStart}
                isDraggedOver={draggedOverDepartment?.id === mainDepartment.id}

                onAddSubDepartment={() => addNewDepartmnent({ parentId: mainDepartment.id })}
                status="general"
                childrensCount={children?.length}
                showChildrens={!hiddenTrees.includes(mainDepartment.id)}
                setShowChildrens={() => toggleTree(mainDepartment.id)}
                onDelete={() => openDeleteConfirmModal({ id: mainDepartment.id, isMainDep: true })}
                openUserInfoModal={createUserInfoModal}
                department={mainDepartment}
                openEditDepModal={() => openEditDepModal({ department: mainDepartment, isMainDep: true })}
                openCreateUser={openCreateUser}
              />

              {!!children?.length && <div className="main-department-group__children">
                {children.map((parent) => {
                  const children = departments.filter((dep) => dep.parentId === parent.id);

                  return (
                    <div className="department-group" key={parent} style={hiddenTrees.includes(mainDepartment.id) ? { display: 'none' } : {}}>
                      <DepartmentCard
                        title={parent.name}
                        employees={employees.filter(empl => empl.departament?.id === parent.id && empl.id !== parent.generalDirector?.id)}
                        generalDirector={parent.generalDirector}

                        onDragOver={e => onDragOverCard(e, parent)}
                        onDrop={(e) => handleDrop(e, parent.id)}
                        onDragStart={handleDragStart}
                        isDraggedOver={draggedOverDepartment?.id === parent.id}

                        onAddSubDepartment={() => addNewDepartmnent({ parentId: parent.id })}
                        status="second"
                        childrensCount={children.length}
                        onDelete={() => openDeleteConfirmModal({ id: parent.id, parentDep: mainDepartment, childrens: children })}
                        setShowChildrens={() => toggleTree(parent.id)}
                        showChildrens={!hiddenTrees.includes(parent.id)}
                        openUserInfoModal={v => createUserInfoModal({ ...v, parentDep: mainDepartment, })}
                        department={parent}
                        openEditDepModal={() => openEditDepModal({ department: parent, parentDepartment: mainDepartment })}

                      />

                      {children.length > 0 && (
                        <div className="department-group__children" style={hiddenTrees.includes(parent.id) ? { display: 'none' } : {}}>
                          {children.map((sub) => {

                            const subchildrens = departments.filter((dep) => dep.parentId === sub.id);

                            return <div className="department-group" key={parent} style={hiddenTrees.includes(mainDepartment.id) ? { display: 'none' } : {}}>
                              <DepartmentCard
                                key={sub.id}
                                title={sub.name}
                                employees={employees.filter(empl => empl.departament?.id === sub.id && empl.id !== sub.generalDirector?.id)}
                                generalDirector={sub.generalDirector}

                                onDragOver={e => onDragOverCard(e, sub)}
                                onDrop={(e) => handleDrop(e, sub.id)}
                                onDragStart={handleDragStart}
                                isDraggedOver={draggedOverDepartment?.id === sub.id}

                                onAddSubDepartment={() => addNewDepartmnent({ parentId: sub.id })} // если parent.id поменять на sub.id то отдел создастся, просто не отобразится
                                status="third"
                                onDelete={() => openDeleteConfirmModal({ id: sub.id, parentDep: parent })}
                                setShowChildrens={() => toggleTree(sub.id)}
                                showChildrens={!hiddenTrees.includes(parent.id)}
                                openUserInfoModal={v => createUserInfoModal({ ...v, parentDep: parent, })}
                                department={sub}
                                openEditDepModal={() => openEditDepModal({ department: sub, parentDepartment: parent })}
                              />
                              {subchildrens.length > 0 && (
                                <div className="department-group__children" style={hiddenTrees.includes(sub.id) ? { display: 'none' } : {}}>
                                  {subchildrens.map((subchild) => {


                                    return <div className="department-group" key={sub} style={hiddenTrees.includes(mainDepartment.id) ? { display: 'none' } : {}}>
                                      <DepartmentCard
                                        key={subchild.id}
                                        title={subchild.name}
                                        employees={employees.filter(empl => empl.departament?.id === subchild.id && empl.id !== subchild.generalDirector?.id)}
                                        generalDirector={subchild.generalDirector}

                                        onDragOver={e => onDragOverCard(e, subchild)}
                                        onDrop={(e) => handleDrop(e, subchild.id)}
                                        onDragStart={handleDragStart}
                                        isDraggedOver={draggedOverDepartment?.id === subchild.id}

                                        onAddSubDepartment={() => addNewDepartmnent({ parentId: sub.id })} // если parent.id поменять на sub.id то отдел создастся, просто не отобразится
                                        status="last"
                                        onDelete={() => openDeleteConfirmModal({ id: subchild.id, parentDep: sub })}
                                        setShowChildrens={() => toggleTree(sub.id)}
                                        showChildrens={!hiddenTrees.includes(sub.id)}
                                        openUserInfoModal={v => createUserInfoModal({ ...v, parentDep: sub, })}
                                        department={subchild}
                                        openEditDepModal={() => openEditDepModal({ department: subchild, parentDepartment: sub })}
                                      />
                                    </div>
                                  })}
                                </div>
                              )}
                            </div>
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>}

            </div>
          })}
        </main>
      </div>
    </>
  );
};


export const SubdivisionModal = ({ department = {}, departments, employees = [], isMainDep, parentDepartment, handleSave, closeModal }) => {//wip

  const { state, setValue, setValues } = useObjectState({
    ...department,
    parentDepartment: departments.find(d => d.id === department.parentId),
    head: employees.find(d => d.id === department.headId)
  })

  return (
    <div className="tree-modal__content">
      <div>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Название подразделения</span>
          <input
            type="text"
            className={"input__control"}
            autoComplete="off"
            value={state?.name}
            onChange={e => setValue("name", e.target.value)}
          />
        </label>
      </div>
      {!isMainDep && <div>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Вышестоящее подразделение</span>
          <Dropdown
            value={state.parentId}
            options={departments.filter(d => d.id !== department.id)}
            onChange={v => setValue("parentId", v)}
            titleKey="name"
          />
        </label>
      </div>}
      {!!employees?.length && <div>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Руководитель</span>
          <Dropdown
            value={state.headId}
            options={[{ id: 0, fullName: 'Не выбран' }, ...employees]}
            onChange={v => setValue("headId", v)}
            titleKey="fullName"
          />
        </label>
      </div>}
      <div className="tree-modal__btns">
        <Button buttonType='secondary' type="button" onClick={closeModal}>Отменить</Button>
        <SubmitButton
          className="btn btn_primary h6"
          type="button"
          onClick={() => {
            handleSave(state)
            closeModal()
          }}
        >
          Сохранить
        </SubmitButton>
      </div>
    </div>
  )
}

export const UserInfoModal = (props) => {
  const { user, departments, userDepartment, getEmployee, access_list: access_listDefault = [], handleSave, closeModal, isGendir, parentDep, companyOwner, disableSave } = props;
  const { state: loadedUser, setValues, setValue } = useObjectState(user) //wip

  useEffect(() => {
    if (getEmployee) getEmployee({ employeeId: user.id }).then(({ resp }) => {
      setValues({ ...resp.employee, access_list: resp.access_list })
    })

  }, [])

  const [selectedDepartment, setSelectedDepartment] = useState(userDepartment?.id);

  const { fullName, photo, position, name, phone, lastName, patronymic, access, email, departament, access_list = access_listDefault, comment = "" } = loadedUser;
  const keyToGD = isGendir || !userDepartment.generalDirector ? "parentDep" : "userDepartment"

  const owner = !!props[keyToGD]?.generalDirector ?
`${props[keyToGD].generalDirector?.name} ${props[keyToGD].generalDirector?.lastName}` : companyOwner ? `${companyOwner?.name} ${companyOwner?.lastName}` : "Назначте руководителя компании";

  return (
    <>
      <div className="tree-modal__user-info">
        <Link className="link linktoprofile link_color-red" to={`/personalcabinet/employee/${user.id}`}>
          Перейти в профиль сотрудника
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.819 13.2792L15.7466 8.89684" stroke="#EF372E" stroke-linecap="round" />
            <path d="M15.4989 8.64908L11.1166 8.57668" stroke="#EF372E" stroke-linecap="round" />
            <path d="M15.7577 8.63829L7.82797 16.568" stroke="#EF372E" stroke-linecap="round" />
          </svg>
        </Link>
        <div className="create-company__block create-company__block_dark">
          <div className="create-company__manager">
            <img src={photo?.src} className="create-company__manager-img" alt="" />
            <div className="create-company__manager-info">
              <p className="create-company__manager-name">{fullName || `${name} ${lastName}`}</p>
              <div className="create-company__manager-seconodinfo">
                <div>
                  {!!phone && <div><a href={`tel:${phone}`} className="create-company__manager-phone link link_color_black">{phone}</a></div>}
                  {email && <div><a href={`mailto:${email}`} className="create-company__manager-email link link_color_black">{email}</a></div>}
                </div>
                <div className="create-company__manager-social">
                  <Link><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="white" /><path d="M22.2 9.02576L7.46685 13.1746C7.34133 13.2086 7.22935 13.2805 7.14618 13.3805C7.06302 13.4805 7.0127 13.6037 7.0021 13.7333C6.9915 13.8629 7.02113 13.9926 7.08695 14.1048C7.15277 14.217 7.25157 14.3061 7.3699 14.3601L14.1353 17.5605C14.2676 17.6221 14.3739 17.7285 14.4356 17.8608L17.6391 24.6293C17.6929 24.7477 17.7819 24.8466 17.8939 24.9125C18.0059 24.9785 18.1356 25.0084 18.2652 24.998C18.3948 24.9876 18.518 24.9376 18.6181 24.8546C18.7183 24.7717 18.7904 24.6599 18.8247 24.5345L22.9745 9.8003C23.0209 9.6417 23.0027 9.47116 22.9237 9.326C22.8447 9.18085 22.7114 9.07289 22.553 9.02576C22.4378 8.99141 22.3151 8.99141 22.2 9.02576V9.02576Z" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round" /><path d="M14.3439 17.6563L17.9162 14.084" stroke="#2C2E3E" stroke-linecap="round" stroke-linejoin="round" /></svg></Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Уровень доступа</span>
            <Dropdown
              value={access}
              options={access_list}
              onChange={v => setValue("access", v)}
              valueKey="value"
            />
          </label>
        </div>

        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Отдел</span>
            <Dropdown
              value={selectedDepartment}
              options={departments}
              onChange={v => setSelectedDepartment(v)}
              titleKey="name"
            />
          </label>
        </div>

        {userDepartment?.generalDirector && <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Руководитель</span>
            <input
              type="text"
              className={"input__control"}
              autoComplete="off"
              disabled
              value={owner}
            />
          </label>
        </div>}
        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Должность</span>
            <input
              type="text"
              className={"input__control"}
              autoComplete="off"
              value={position}
              onChange={e => setValue("position", e.target.value)}
            />
          </label>
        </div>
        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Комментарий</span>
            <textarea
              className="cabinet-textarea"
              placeholder="По желанию Вы можете указать дополнительную информацию о сотруднике"
              value={comment}
              onChange={e => setValue("comment", e.target.value)}
            ></textarea>
          </label>
        </div>

      </div>
      <div className="tree-modal__btns">
        <Button buttonType='secondary' onClick={closeModal}>Отменить</Button>
        <SubmitButton
          className="btn btn_primary h6"
          type="button"
          disabled={disableSave}
          onClick={() => handleSave({
            ...loadedUser,
            departmentId: selectedDepartment || userDepartment?.id,

          })}
        >
          Сохранить
        </SubmitButton>
      </div>
    </>
  )
}


export const UserCreateModal = ({ handleSave, closeModal }) => {

  const { state, setValues, setValue } = useObjectState({}) //wip

  const { data: { departments = [], employees = [], positions = [], access_list = [] }, isLoading, dataSetter, send, isSending } = useApi({
    payload: ["panpartner:company.ajax", "getMyCompany",]
  })

  const addEmployee = (params) => {
    return send(["panpartner:company.ajax", "addEmployee", toFormData(params, "params")])
      .then(r => {
        dataSetter("employees", prev => ([...(Array.isArray(prev) ? prev : []), params]))
        closeModal()
        standartSuccessToast(r)
      }, standartErrorToast)
  }

  const {
    inn = "",
    photo,
    position,
    name = "",
    phone = "",
    lastName = "",
    patronymic = "",
    access = "limited_access",
    email = "",
    comment = "",
    errors = []
  } = state;
  const onSave = () => {
    const errors = filterAndMap(["inn", "phone", "name", "lastName", "access", "email"], key => !state[key]?.replace?.(/[ ,'`"]/gi, "")?.length ? key : false)
    if (errors?.length) return setValue("errors", errors)
    handleSave ? handleSave({ params: state }).then(r => closeModal()) : addEmployee(state)

  }

  const getInputCls = key => classNames({
    "input__control": true,
    "input__error": errors.includes(key),
  })

  const ErrLabel = ({ inputKey }) => errors.includes(inputKey) && (
    <span className="input__error-label">
      Поле заполнено некорректно
    </span>
  )
  return (
    <>
      <div className="tree-modal__user-info">
        <label className="input input_type_form input_width_available">
          <span className="input__label">Фамилия</span>
          <input
            type="text"
            className={getInputCls("lastName")}
            autoComplete="off"
            value={lastName}
            onChange={e => setValue("lastName", e.target.value)}
            placeholder='Фамилия'
          />
          <ErrLabel inputKey="lastName" />
        </label>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Имя</span>
          <input
            type="text"
            className={getInputCls("name")}
            autoComplete="off"
            value={name}
            onChange={e => setValue("name", e.target.value)}
            placeholder='Имя'
          />
          <ErrLabel inputKey="name" />
        </label>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Отчество</span>
          <input
            type="text"
            className={getInputCls("patronymic")}
            autoComplete="off"
            value={patronymic}
            onChange={e => setValue("patronymic", e.target.value)}
            placeholder='Отчество'
          />
          <ErrLabel inputKey="patronymic" />
        </label>
        <label className="input input_type_form input_width_available">
          <span className="input__label">Телефон</span>
          <InputMask
            type="text"
            className={getInputCls("phone")}
            mask="+7 (999) 999-99-99"
            autoComplete="off"
            maskChar=" "
            value={phone}
            onChange={(e) => setValue("phone", e.target.value)}
            placeholder='+7 (___) ___-__-__'
          />
          <ErrLabel inputKey="phone" />
        </label>
        <label className="input input_type_form input_width_available">
          <span className="input__label">E-mail</span>
          <input
            type="text"
            className={getInputCls("email")}
            autoComplete="off"
            value={email}
            onChange={e => setValue("email", e.target.value)}
            placeholder='E-mail'
          />
          <ErrLabel inputKey="email" />
        </label>
        <label className="input input_type_form input_width_available">
          <span className="input__label">ИНН</span>
          <input
            type="text"
            className={getInputCls("inn")}
            autoComplete="off"
            value={inn}
            onChange={e => setValue("inn", e.target.value)}
            placeholder='ИНН'
          />
          <ErrLabel inputKey="inn" />
        </label>
        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Уровень доступа</span>
            <Dropdown
              value={access}
              options={access_list}
              onChange={v => setValue("access", v)}
              valueKey="value"
            />
            <ErrLabel inputKey="access" />
          </label>
        </div>

        {/* 
        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Должность</span>
            <input
              type="text"
              className={"input__control"}
              autoComplete="off"
              value={position}
              onChange={e => setValue("position", e.target.value)}
            />
          </label>
        </div>
        <div>
          <label className="input input_type_form input_width_available">
            <span className="input__label">Комментарий</span>
            <textarea
              className="cabinet-textarea"
              placeholder="По желанию Вы можете указать дополнительную информацию о сотруднике"
              value={comment}
              onChange={e => setValue("comment", e.target.value)}
            ></textarea>
          </label>
        </div> */}

      </div>
      <div className="tree-modal__btns">
        <Button buttonType='secondary' onClick={closeModal}>Отменить</Button>
        <SubmitButton
          className="btn btn_primary h6"
          type="button"
          onClick={onSave}
          isLoading={isSending || isLoading}
        >
          Добавить сотрудника
        </SubmitButton>
      </div>
    </>
  )
}